<div class="next-step-container">
  <div class="content">
    <kion-headline-tag *ngIf="component.title" [titleSize]="component.titleSize" [title]="component.title"></kion-headline-tag>
    <div class="grid">
      <div class="block {{block.completed ? 'completed' : ''}}" *ngFor="let block of components$ | async">
        <div class="headline">
          <div class="step" *ngIf="!block.icon; else icon">{{block.stepNumber}}</div>
          <ng-template #icon>
            <div class="step icon">
              <img [src]="block.icon" />
            </div>
          </ng-template>
          <h5>{{block.title}}</h5>
        </div>
        <div class="description">{{ block.description }}</div>
      </div>
    </div>
  </div>
</div>
